'use client'
import { Button } from '@/components/ui/button'
import { cn } from '@/utils/cn'
import Image from 'next/image'
import { NotificationButtonProps } from '..'

export const NotificationImageButton = ({
  id,
  price,
  priceLowest,
  notifiedStatus,
  onClickNotificationButton,
  className,
  ...props
}: NotificationButtonProps) => {
  return (
    <Button
      className={cn(
        'flex size-[60px] items-center justify-center rounded-lg bg-black p-0',
        className,
      )}
      onClick={(e) => {
        e.preventDefault()
        onClickNotificationButton(e)
      }}
      {...props}
    >
      <Image
        src={`/icons/상품상세_알림_${notifiedStatus === 'notified' ? 'on' : 'off'}.svg`}
        width={38}
        height={38}
        className="size-[38px]"
        alt="열기"
      />
    </Button>
  )
}
